import {IDynamicDataConfig} from '~/interfaces/dynamicFieldsInterfaces'
import Guid from '~/helpers/guid'

export default class ProcessFlowDynamicFieldHandlerSelectMixin {
  constructor(private handler) {
  }

  /**
   * Whenever a mapped variable is being used in a formula, need to have the id be a guid that will be the client_id
   * of the mapped variable the formula references. This client_id is what is stored in the formula string.
   *
   * @param selectedItem
   * @param config
   * @private
   */
  select(selectedItem: object, config: Omit<IDynamicDataConfig, 'id'>): IDynamicDataConfig {
    return this.handler.select(selectedItem, { ...config, id: Guid.create() })
  }
}